module.exports = __webpack_public_path__ + "static/media/buta.e33a2b2f.jpg";